var map = {
	"./amadeus/CardholderFeedback.json": 1269,
	"./barlcays/CardholderFeedback.json": 1270,
	"./cb911/CardholderFeedback.json": 1271,
	"./choiceHotels/CardholderFeedback.json": 1272,
	"./globex/CardholderFeedback.json": 1273,
	"./kraken/CardholderFeedback.json": 1274,
	"./lastminute/CardholderFeedback.json": 1275,
	"./monavate/CardholderFeedback.json": 1276,
	"./outpayce/CardholderFeedback.json": 1277,
	"./sofi/CardholderFeedback.json": 1278
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1268;